module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABMklEQVQ4jZWTMW/CMBCFvwsICXnBdGHvD4KFEbGxMYehbAzmH6BsUfYI/k87MhazWEFIhA6taRIZSt/0zr73zne2BSDLsqFz7g14AUoeIwI+lVKryWSykzRNh0VRbKsZ5/MZ5xzX6xUAEUEpRafTqTkppUbtoiiWTfFgMGA8HteS8zxnv9/XTJxzyzbQ9wvWWqy1zOdzZrMZvV4PgOPxSJIkxHGM1hqttZf0ZbPZvAOv1loWi8Uf7X/DGONNPqKnFA/Q9kRrjTEGa+1teE2ISLOFXwOP9Xr9sKIxphbXWqhWjuM4yJunuzuDy+US5E3cNYiiKMifNijLMshDBkGTVqsV5E19BBx8JCK3neptVHk1BzhImqbD0+m09dN95h14KKVGAvDzI//1nbvd7mo6ne6+AB+zf9f/5Fb9AAAAAElFTkSuQmCC"


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/fav-delete.png
 ** module id = 205
 ** module chunks = 0 1
 **/